import { render, staticRenderFns } from "./SiteTypeSelect.vue?vue&type=template&id=85868db6&scoped=true"
import script from "./SiteTypeSelect.vue?vue&type=script&lang=js"
export * from "./SiteTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85868db6",
  null
  
)

export default component.exports